import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("eden_jwt");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const CATEGORY_IMAGES = {
    heart: "https://images.unsplash.com/photo-1614366521568-5ed2403107b1?w=1200&auto=format&fit=crop&q=80",
    body: "https://images.unsplash.com/photo-1523248948644-586f1ab2a83e?w=1200&auto=format&fit=crop&q=80",
    mind: "https://images.unsplash.com/photo-1730906599830-c0ec0878856b?w=1200&auto=format&fit=crop&q=80",
    home: "https://images.unsplash.com/photo-1736247849829-015ba9b3c61e?w=1200&auto=format&fit=crop&q=80",
    relationships: "https://images.unsplash.com/photo-1614366521568-5ed2403107b1?w=1200&auto=format&fit=crop&q=80",
    work: "https://images.unsplash.com/photo-1523248948644-586f1ab2a83e?w=1200&auto=format&fit=crop&q=80",
    rest: "https://images.unsplash.com/photo-1730906599830-c0ec0878856b?w=1200&auto=format&fit=crop&q=80",
    kingdom: "https://images.unsplash.com/photo-1736247849829-015ba9b3c61e?w=1200&auto=format&fit=crop&q=80",
};

export const SEASON_OPTIONS = [
    "My relationship with God",
    "My marriage",
    "My children",
    "My health",
    "My home",
    "My finances",
    "My career",
    "My business",
    "My calling",
    "Ministry",
    "Healing",
    "Education",
    "Other",
];
